// @ts-check

const service = process.env.VUE_APP_SERVICE

// New design system color palette 2023
const baseColors = {
  current: 'currentColor',
  transparent: 'transparent',
  white: '#ffffff',
  'off-white': '#fcfcfd', // "surface"
  black: '#181818',
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    DEFAULT: '#1f2937',
    900: '#111827'
  },
  green: {
    50: '#e0f4ef',
    100: '#b4e3d7',
    200: '#83d2bd',
    300: '#51bfa3',
    400: '#29b091',
    DEFAULT: '#29b091',
    500: '#00a17f',
    600: '#009472',
    700: '#008363',
    800: '#007355',
    900: '#00573a',
    opacity10: 'rgb(0,186,130,0.1)'
  },
  orange: {
    50: '#fcf0e4',
    100: '#fcd8b6',
    200: '#fcbd82',
    300: '#fba251',
    400: '#fa8e31',
    500: '#ff8000',
    DEFAULT: '#ff8000',
    600: '#f3701e',
    700: '#ec601f',
    800: '#e44f1e',
    900: '#d6491a',
    opacity10: 'rgba(255,128,0,0.1)'
  },
  purple: {
    50: '#efe4ee',
    100: '#e7d1e5',
    200: '#cc96c4',
    300: '#b76ead',
    400: '#a7519c',
    DEFAULT: '#a7519c',
    500: '#97398c',
    600: '#8b3486',
    700: '#84277a',
    800: '#791e6d',
    900: '#6e1963',
    opacity10: 'rgba(167, 81, 156, 0.1)'
  },
  red: {
    50: '#FEE8E7',
    100: '#FFC9BA',
    200: '#FFA58E',
    300: '#FF7F61',
    400: '#FF5F3F',
    500: '#FF4529',
    600: '#F8311A',
    700: '#EC200F',
    DEFAULT: '#EC200F',
    800: '#DB1905',
    900: '#C80002'
  },
  blue: {
    50: '#EAF0FF',
    100: '#CED8F5',
    200: '#A8B5DD',
    300: '#8597C9',
    400: '#6175B3',
    500: '#455DA7',
    DEFAULT: '#455DA7',
    600: '#3E559D',
    700: '#364B91',
    800: '#2E4285',
    900: '#23316E'
  },
  // Old colors
  yellow: '#ffe600',
  pink: '#FF1717'
}

const baseThemeColors = {
  secondary: baseColors.gray,
  success: {
    ...baseColors.green,
    light: baseColors.green['50'],
    medium: baseColors.green['100'],
    dark: baseColors.green['800']
  },
  warning: {
    ...baseColors.orange,
    light: baseColors.orange['50'],
    medium: baseColors.orange['100'],
    dark: baseColors.orange['800']
  },
  danger: {
    ...baseColors.red,
    light: baseColors.red['50'],
    medium: baseColors.red['100'],
    dark: baseColors.red['800']
  },
  info: {
    ...baseColors.orange,
    light: baseColors.orange['50'],
    medium: baseColors.orange['100'],
    dark: baseColors.orange['800']
  },
  positive: baseColors.green.DEFAULT,
  accent: baseColors.yellow,
  background: baseColors['off-white'],
  curtain: 'rgba(0,0,0,0.1)',
  'curtain-white': 'rgba(255, 255, 255, 0.1)',
  lightgreen: baseColors.green.opacity10
}

export const ukkoproTheme = {
  ...baseColors,
  ...baseThemeColors,
  primary: {
    ...baseColors.orange,
    light: baseColors.orange['50'],
    medium: baseColors.orange['300']
  }
}

export const tlpTheme = {
  ...baseColors,
  ...baseThemeColors,
  primary: {
    ...baseColors.purple,
    light: baseColors.purple['50'],
    medium: baseColors.purple['300']
  }
}

export const themes = {
  tlpTheme,
  ukkoproTheme
}

export const colors = themes[`${service}Theme`] || themes.ukkoproTheme
